import { AccountInfo } from "@azure/msal-browser";
import { StringDict } from "msal/lib-commonjs/MsalTypes";


export class AuthenticatedUser  {
    constructor(public id: string = ``,         
                // public name: string = ``,
                public email: string = ``,
                //public originalUserId: string = ``,
                public userRoles: string[] = [],
                // public securityGroup: string = ``,
                public firmNumber: string = ``,
                public impersonatedFirmId: string = ``) {
    }

    // initials = () => {
    //     if (this.name) {
    //         return `${this.name.substring(0, 1)}${this.lastName().substring(0, 1)}`;
    //     } else {
    //         return '';
    //     }        
    // }

    // lastName = (): string => {
    //     if (this.name) {    
    //         let name = this.name.split(' ' );
    //         return name[name.length - 1];
    //     } else {
    //         return '';
    //     }
    // }

    isALAS = (): boolean => {
        return this.email.endsWith("@alas.com");
    }

    isAuthorized = (): boolean => {
        return true; // As of the addition of MapView, all ALAS users are permitted to access this application.
    }
    
}

function parseJwt(token: string): Record<string, any> {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
    );
    return JSON.parse(jsonPayload);
}

export const convertToAuthenticatedUser = (idToken: string): AuthenticatedUser => {
    const idTokenDict = parseJwt(idToken);

    const roles: string[] = [...idTokenDict.userRoles];
    return new AuthenticatedUser(
        idTokenDict.sub,
        // idToken.name,
        idTokenDict.email,
        //idToken.originalUserId,
        roles,
        // idToken.securityGroup,
        idTokenDict.firmNumber,
        ""
    );
}